import React, { useEffect, useState } from 'react';

import { LayoutDashboard } from '../../layouts/layout-dashboard';
import { Nav } from '../../components/nav';
import { Breadcrumb } from '../../components/breadcrumb';
import { Search } from '../../components/search';
import { CardCombination } from '../../components/card-combination';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useAxios } from '../../hooks/useAxios';
import { BackButton } from '../../components/button-back';
import { PROVIDER_XERO, PROVIDER_OUTLOOK, PROVIDER_GOOGLE_DRIVE, PROVIDER_GOOGLE_SHEETS } from '../../constants';
import { Console } from '../../services/platform-api';
//import { BetaRight } from '../../components/beta-header';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { Preloader } from '../../components/preloader';
import { GetActiveConnections } from '../../data/workato/get-active-connections';
import { filterVotesData, authorizeCombo } from './combinations.func';
import WFSettings from '../../data/platform/workflow_settings.json';

const Combinations = (props) => {
  const { id } = useParams();
  const { pagename } = useParams();
  const [combinationsData, setCombinationsData] = useState([]);
  const { loading, data, error, fetchNow } = useAxios();
  const [isloading, setIsloading] = useState(true);
  const [isFetching, setIsFetching] = useState(1);
  const [isFetching2, setIsFetching2] = useState(0);
  const [userId] = useSessionStorage('userId', 0);

  const { cons_data } = GetActiveConnections();

  useEffect(() => {
    if (loading) return;
    if (isFetching === 1) {
      fetchNow(`/api/platform/workflows/${id}/`, 'GET', null, false);
      setIsFetching(2);
    } else if (isFetching === 2 && data) {
      setCombinationsData(data?.combinations);
      setIsFetching(0);
      setIsFetching2(1);
    }
  }, [isFetching, id, fetchNow, data]);

  useEffect(() => {
    if (loading) return;
    if (isFetching2 === 1) {
      fetchNow(`/api/platform/votes`, 'GET', null, false);
      setIsFetching2(2);
    } else if (isFetching2 === 2 && data[0]?.combination_id) {
      if (data) {
        let updatedCombinationsData = filterVotesData(userId, data, combinationsData);
        updatedCombinationsData = authorizeCombo(updatedCombinationsData, cons_data);

        setCombinationsData(updatedCombinationsData);
        setIsloading(false);
      }
      setIsFetching2(0);
    }
  }, [combinationsData, isFetching2, data, loading]);

  if (error) {
    console.log('error', error);
    return null;
  }

  return (
    <>
      <div className="dashboard">
        <header>
          <Container fluid>
            <Row>
              <Col lg={8} className="px-5">
                <Breadcrumb label={pagename.replace(/-/g, ' ')} />
                <h1>Combinations</h1>
              </Col>
              <Col lg={4} className="px-5">
                {/* <BetaRight /> */}
              </Col>
            </Row>
          </Container>
        </header>

        <LayoutDashboard>
          <Row>
            {isloading ? (
              <Preloader />
            ) : combinationsData ? (
              combinationsData
                .sort((a, b) => (a.order > b.order ? -1 : 1))
                .sort((a, b) => (a.votes > b.votes ? -1 : 1))
                .sort((a) => (a.status === 'coming_soon' ? 1 : -1))
                .map((combinationData, key) => {
                  return (
                    <Col xxlg={4} xl={4} lg={6} md={12} key={key}>
                      <CardCombination combinationData={combinationData} />
                    </Col>
                  );
                })
            ) : combinationsData?.length === 0 ? (
              <Col lg={12} className="text-center">
                <h3 className="mb-4">Sorry, no content available at the moment.</h3>
                <BackButton />
              </Col>
            ) : null}
          </Row>
        </LayoutDashboard>

        <Nav nav1on="on" nav2on="" nav3on="" {...props} />
      </div>
    </>
  );
};

export { Combinations };
